import ChatDrawer from "../../components/chat-drawer";

const ChatDrawerOutlet = <template>
  <div class="below-footer-outlet chat-drawer-outlet">
    <div class="chat-drawer-outlet-container">
      <ChatDrawer />
    </div>
  </div>
</template>;

export default ChatDrawerOutlet;
